import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get('token');
    const refreshToken = searchParams.get('refresh');

    console.log('AuthCallback - URL:', window.location.href);
    console.log('AuthCallback - Token received:', !!token, 'Token length:', token?.length);
    console.log('AuthCallback - Refresh token received:', !!refreshToken, 'Refresh length:', refreshToken?.length);
    console.log('AuthCallback - All search params:', Object.fromEntries(searchParams.entries()));

    if (token && refreshToken) {
      // Store tokens
      localStorage.setItem('accessToken', token);
      localStorage.setItem('refreshToken', refreshToken);
      console.log('AuthCallback - Tokens stored in localStorage');
      console.log('AuthCallback - Verifying storage:', {
        accessToken: !!localStorage.getItem('accessToken'),
        refreshToken: !!localStorage.getItem('refreshToken')
      });

      // Small delay to ensure localStorage is set before navigation
      setTimeout(() => {
        console.log('AuthCallback - Navigating to /');
        navigate('/', { replace: true });
      }, 100);
    } else {
      console.error('AuthCallback - Missing tokens in URL');
      console.error('AuthCallback - Token:', token);
      console.error('AuthCallback - Refresh:', refreshToken);
      // No tokens, redirect to login
      navigate('/login?error=auth_failed', { replace: true });
    }
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
        <p className="text-gray-700">Completing sign in...</p>
      </div>
    </div>
  );
}

